import { observer } from 'mobx-react-lite'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { AppCircularRating } from 'src/component/common/analog/molecule/AppCircularRating'
import { SkillSet } from '../../../skill-assessment/model/skill-assessment-model'
import { useSkillRatingModal } from 'src/feature/dashboard/hooks/useSkillRatingModal'

/**
 * Props for SkillRatingGrid component
 */
interface SkillRatingGridProps {
  skills: SkillSet[]
  isAllSkillsRated: boolean
  defaultColor: string
}

/**
 * Renders a grid of skill rating circular indicators
 * Displays skill ratings with interactive rating buttons
 */
export const SkillRatingGrid = observer(({
  skills,
  isAllSkillsRated,
  defaultColor,
}: SkillRatingGridProps) => {
  const { handleRateSkillClick } = useSkillRatingModal()

  return (
    <AppBox sx={styles.ratingWrapper}>
      {skills?.map((skill: SkillSet, index: number) => (
        <AppCircularRating
          size={140}
          key={skill.id}
          indexKey={index}
          userRating={skill.selectedSetLevel}
          expectedRating={skill.expected_set_level}
          label={skill.setName}
          showRating={isAllSkillsRated}
          showLevelBtn={true}
          onRateSkillClick={(selectedIndex: number) => handleRateSkillClick(selectedIndex)}
          viewLabel='UserView'
          defaultColor={defaultColor}
          isValidated={skill.isValidated}
        />
      ))}
    </AppBox>
  )
})

const styles = {
  ratingWrapper: {
    display: 'grid',
    gridTemplateColumns: {
      xs: 'repeat(auto-fit, 160px)',
      md: 'repeat(auto-fit, minmax(160px, 1fr))',
    },
    justifyContent: 'center',
    rowGap: 40,
    columnGap: 40,
    width: '100%',
    maxWidth: 'calc(5 * 160px + 4 * 40px)',
    margin: '0 auto',
  },
}
